<template>
    <div class="ip-marquee" >
        <div class="ip-title">
            <img src="https://cdn.magicmart.vip/website/assets/ip.png" />
        </div>
        <div class="marquee-row marquee-row-fast">
            <div class="marquee-content" :style="{ animationDuration: slowSpeed }">
                <div v-for="(item, index) in fastRowItems" :key="'fast-' + index" class="marquee-item">
                    <img :src="item.image" :alt="item.name">
                </div>
            </div>
            <div class="marquee-content" :style="{ animationDuration: slowSpeed }">
                <div v-for="(item, index) in fastRowItems" :key="'fast-dup-' + index" class="marquee-item">
                    <img :src="item.image" :alt="item.name">
                </div>
            </div>
        </div>

        <div class="marquee-row marquee-row-slow">
            <div class="marquee-content" :style="{ animationDuration: fastSpeed }">
                <div v-for="(item, index) in slowRowItems" :key="'slow-' + index" class="marquee-item">
                    <img :src="item.image" :alt="item.name">
                </div>
            </div>
            <div class="marquee-content" :style="{ animationDuration: fastSpeed }">
                <div v-for="(item, index) in slowRowItems" :key="'slow-dup-' + index" class="marquee-item">
                    <img :src="item.image" :alt="item.name">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IpList',
    data() {
        return {
            fastSpeed: '10s',
            slowSpeed: '30s',
            fastRowItems: [
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip1.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip2.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip3.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip4.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip9.png' }
            ],
            slowRowItems: [
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip5.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip6.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip7.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip8.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip10.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip11.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip12.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip13.png' },
                { image: 'https://cdn.magicmart.vip/website/assets/ip/ip14.png' }
            ]
        }
    }
}
</script>

<style scoped>
.ip-marquee {
    width: 100%;
    background: #fff;
    padding-top: 145px;
}

.ip-title {
    width: 337px;
    height: 94px;
    margin: 0 auto;

    margin-bottom: 107px;
}

.ip-title img {
    width: 100%;
    height: 100%;
}

.marquee-row {
    width: 100%;
    height: 143px;
    overflow: hidden;
    margin-bottom: 40px;
    display: flex;
}

.marquee-row:last-child {
    margin-bottom: 0;
}

.marquee-content {
    display: flex;
    align-items: center;
    animation: marquee linear infinite;
    will-change: transform;
}

.marquee-row-fast .marquee-content {
    animation-name: marquee-left;
}

.marquee-row-slow .marquee-content {
    animation-name: marquee-right;
}

@keyframes marquee-left {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}

@keyframes marquee-right {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}

.marquee-item {
    flex-shrink: 0;
    width: 369px;
    height: 123px;
    margin-right: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 17px;
}

.marquee-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
